import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const insertAudit = async (auditData) => {
  try {
    const response = await axios.post(`${API_URL}/audit`, auditData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    // HIPAA: no loguear error.response.data (puede contener PHI) — 45 CFR 164.530(c)
    console.error("Error inserting audit:", error?.response?.status, error?.message);
    throw error;
  }
};

export default insertAudit;
